<template>
  <div v-if="banners.length" class="promo-banner-strip">
    <a
      class="promo-banner-strip__slide"
      :href="current.link_url || undefined"
      :target="current.link_url ? '_blank' : undefined"
      :rel="current.link_url ? 'noopener noreferrer' : undefined"
      :class="{ 'is-static': !current.link_url }"
      @click="onClick"
    >
      <img :src="current.image_url" :alt="current.title || 'Banner promocional'" />
    </a>
    <div v-if="banners.length > 1" class="promo-banner-strip__dots">
      <button
        v-for="(b, i) in banners"
        :key="b.id"
        type="button"
        class="promo-banner-strip__dot"
        :class="{ active: i === index }"
        @click="index = i"
        :aria-label="`Banner ${i + 1}`"
      />
    </div>
  </div>
</template>

<script>
import PromoBannersHttp from "@/http/PromoBannersHttp";

export default {
  name: "PromoBannerCarousel",
  data() {
    return {
      banners: [],
      index: 0,
      timer: null,
    };
  },
  computed: {
    current() {
      return this.banners[this.index] || {};
    },
  },
  mounted() {
    this.load();
    window.addEventListener("rifa365:promo-banners-updated", this.load);
  },
  beforeUnmount() {
    this.clearTimer();
    window.removeEventListener("rifa365:promo-banners-updated", this.load);
  },
  methods: {
    async load() {
      try {
        const res = await PromoBannersHttp.listActive();
        const list = Array.isArray(res.data?.data)
          ? res.data.data
          : Array.isArray(res.data)
            ? res.data
            : [];
        this.banners = list.filter((b) => b && b.image_url);
        this.index = 0;
        this.startTimer();
      } catch (e) {
        this.banners = [];
        this.clearTimer();
      }
    },
    startTimer() {
      this.clearTimer();
      if (this.banners.length < 2) return;
      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.banners.length;
      }, 5000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    onClick(e) {
      if (!this.current.link_url) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
.promo-banner-strip {
  position: relative;
  width: 100%;
  margin: 0.75rem 0 0.25rem;
  border-radius: 14px;
  overflow: hidden;
  background: #0f172a;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.promo-banner-strip__slide {
  display: block;
  line-height: 0;
}

.promo-banner-strip__slide.is-static {
  cursor: default;
}

.promo-banner-strip__slide img {
  width: 100%;
  height: auto;
  max-height: 120px;
  object-fit: cover;
  display: block;
}

.promo-banner-strip__dots {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 8px;
  display: flex;
  justify-content: center;
  gap: 6px;
  pointer-events: none;
}

.promo-banner-strip__dot {
  pointer-events: auto;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.45);
  padding: 0;
  cursor: pointer;
}

.promo-banner-strip__dot.active {
  background: #fff;
}

@media (min-width: 1200px) {
  .promo-banner-strip__slide img {
    max-height: 140px;
  }
}
</style>
